/**
 * Intro/onboarding session gate.
 *
 * Behaviour requested by product: the intro screen must appear every time the
 * user opens the app in a fresh browser session, even if they have already
 * picked a city in a previous session. A simple in-tab refresh should NOT
 * re-show the intro — only a brand-new session (new tab/window).
 *
 * We keep the saved city in localStorage (so it pre-fills onboarding next
 * time) but gate Home rendering on `sessionStorage`, which clears when the
 * tab is closed.
 */
const SESSION_KEY = 'gotravlr:session-introduced';

export function isSessionIntroduced() {
  try { return sessionStorage.getItem(SESSION_KEY) === '1'; } catch { return false; }
}

export function markSessionIntroduced() {
  try { sessionStorage.setItem(SESSION_KEY, '1'); } catch { /* ignore */ }
}

export function clearSessionIntroduced() {
  try { sessionStorage.removeItem(SESSION_KEY); } catch { /* ignore */ }
}
